var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UNBXD } from '../../config/config';
/**
 * Generate or retrieve a unique user ID for Unbxd tracking
 */
function getUnbxdUserId() {
    const storageKey = 'unbxd_user_id';
    let userId = localStorage.getItem(storageKey);
    if (!userId) {
        userId = `uid_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        localStorage.setItem(storageKey, userId);
    }
    return userId;
}
/**
 * Detect device type for Unbxd
 */
function getDeviceType() {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/mobile|android|iphone|ipad|tablet/.test(userAgent)) {
        return /tablet|ipad/.test(userAgent) ? 'tablet' : 'mobile';
    }
    return 'desktop';
}
/**
 * Get client IP (this would normally come from server-side)
 */
function getClientIP() {
    // In a real implementation, this would come from the server
    // For now, return a placeholder
    return '0.0.0.0';
}
export function fetchUnbxd(r) {
    return __awaiter(this, void 0, void 0, function* () {
        // Calculate offset from page number
        const page = r.page || 1;
        const pageSize = r.pageSize || 24;
        const start = (page - 1) * pageSize;
        const params = new URLSearchParams({
            q: r.q || '*',
            start: String(start),
            rows: String(pageSize),
            'facet.multiselect': 'true',
            'facet.version': 'V2',
            version: 'V2',
            'f.categoryPath.facet.limit': '100',
            'f.brand.facet.limit': '100',
        });
        // Add variants parameter if needed
        params.append('variants', 'true');
        params.append('variants.count', '5');
        if (r.sort) {
            const sortMap = {
                'price asc': 'price asc',
                'price desc': 'price desc',
                'title asc': 'title asc',
                'title desc': 'title desc',
                'relevance': 'relevance',
                'popularity': 'popularity desc',
                'rating': 'rating desc'
            };
            params.append('sort', sortMap[r.sort] || r.sort);
        }
        // Handle filters
        if (r.filters) {
            Object.entries(r.filters).forEach(([filterId, values]) => {
                if (values.length > 0) {
                    if (filterId === 'price') {
                        // Price range filter
                        const lastValue = values[values.length - 1];
                        const [min, max] = lastValue.split(',').map(Number);
                        const priceFilter = `price:[${min} TO ${max}]`;
                        params.append('filter', priceFilter);
                    }
                    else {
                        // Text filters with OR logic
                        const filterValue = values
                            .map((value) => `${filterId}:"${value}"`)
                            .join(' OR ');
                        params.append('filter', filterValue);
                    }
                }
            });
        }
        // Add fields parameter to get all product fields
        params.append('fields', '*');
        // Add merchandising parameters
        if (r.merchandising) {
            const merch = r.merchandising;
            // Enable merchandising
            if (merch.enabled !== false) {
                params.append('merchandising', 'true');
            }
            // Pin products
            if (merch.pins && merch.pins.length > 0) {
                merch.pins.forEach((pin, index) => {
                    if (typeof pin.position === 'number') {
                        params.append(`pin.uniqueId.${index}`, pin.productId);
                        params.append(`pin.slotNum.${index}`, String(pin.position));
                    }
                    else {
                        // Range pinning
                        params.append(`pin.uniqueId.${index}`, pin.productId);
                        params.append(`pin.slotNum.${index}`, `${pin.position.start}-${pin.position.end}`);
                    }
                });
            }
            // Boost/bury products
            if (merch.boosts && merch.boosts.length > 0) {
                merch.boosts.forEach((boost, index) => {
                    params.append(`boost.uniqueId.${index}`, boost.productId);
                    params.append(`boost.boostScore.${index}`, String(boost.score));
                });
            }
            // A/B test parameters
            if (merch.abTest) {
                if (merch.abTest.experimentId) {
                    params.append('experiment.id', merch.abTest.experimentId);
                }
                if (merch.abTest.variantId) {
                    params.append('variant.id', merch.abTest.variantId);
                }
            }
            // Rule contexts
            if (merch.ruleContexts && merch.ruleContexts.length > 0) {
                params.append('rule-context', merch.ruleContexts.join(','));
            }
        }
        // Construct the correct search endpoint URL
        const url = `${UNBXD.endpoint}/${UNBXD.apiKey}/${UNBXD.siteKey}/search?${params.toString()}&stats=price`;
        try {
            const response = yield fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Accept-Encoding': 'gzip',
                    'unbxd-user-id': getUnbxdUserId(),
                    'user-agent': navigator.userAgent,
                    'unbxd-device-type': getDeviceType(),
                    'X-forwarded-for': getClientIP(),
                    'Content-Type': 'application/json'
                },
            });
            if (!response.ok) {
                const errorText = yield response.text();
                console.error('Unbxd API error response:', errorText);
                throw new Error(`Unbxd API error: ${response.status} ${response.statusText}`);
            }
            const data = yield response.json();
            // Log for debugging
            if (process.env.NODE_ENV === 'development') {
                console.log('Unbxd API Response:', data);
            }
            return data;
        }
        catch (error) {
            console.error('Unbxd API fetch error:', error);
            throw error;
        }
    });
}
